/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './department-ward.reducer';

export const DepartmentWardDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const departmentWardEntity = useAppSelector(state => state.departmentWard.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="departmentWardDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.departmentWard.detail.title">DepartmentWard</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.departmentWard.id">Id</Translate>
            </span>
          </dt>
          <dd>{departmentWardEntity.id}</dd>
          <dt>
            <span id="skillLevel">
              <Translate contentKey="tinyMedicRestApp.departmentWard.skillLevel">Skill Level</Translate>
            </span>
          </dt>
          <dd>{departmentWardEntity.skillLevel}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.departmentWard.active">Active</Translate>
            </span>
          </dt>
          <dd>{departmentWardEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.departmentWard.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{departmentWardEntity.cursor}</dd>
          <dt>
            <span id="lastUpdate">
              <Translate contentKey="tinyMedicRestApp.departmentWard.lastUpdate">Last Update</Translate>
            </span>
          </dt>
          <dd>{departmentWardEntity.lastUpdate}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.departmentWard.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{departmentWardEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.departmentWard.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{departmentWardEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.departmentWard.ward">Ward</Translate>
          </dt>
          <dd>{departmentWardEntity.ward ? departmentWardEntity.ward.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.departmentWard.department">Department</Translate>
          </dt>
          <dd>{departmentWardEntity.department ? departmentWardEntity.department.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/department-ward" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/department-ward/${departmentWardEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DepartmentWardDetail;
